if (typeof window !== 'undefined') {
  module.exports = require('@rails/activestorage')
} else {
  module.exports = require('../../../activestorageStub')
}
